import React from "react";
import { string } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import TopArrowContainer from "../TopArrowContainer";
import VersionList from "../VersionList";
import { staticTexts } from "../../utils/Translate";

import "./dropdown.m.css";

const Dropdown = ({ label, lang, domainSlug }) => {
  const value = domainSlug === "northamerica" ? "উত্তর আমেরিকা" : staticTexts(lang).language;

  return (
    <div styleName={`wrapper`} className="dropdown">
      <div styleName="edition-label">
        <label styleName="label">{label}</label>
        <span styleName="current-value">{value}</span>
        <i styleName="down" />
        <i styleName="up" />
      </div>
      <div styleName="top-arrow-container-wrapper">
        <TopArrowContainer className="top-arrow-container">
          <VersionList />
        </TopArrowContainer>
      </div>
    </div>
  );
};

Dropdown.propTypes = {
  label: string,
  lang: string,
  domainSlug: string,
};

const mapStateToProps = (state) => ({
  lang: get(state, ["qt", "config", "publisher-attributes", "lang"], ""),
  domainSlug: get(state, ["qt", "config", "domainSlug"], null),
});

export default connect(mapStateToProps, null)(Dropdown);
